import { render } from "./ItemFile.vue?vue&type=template&id=78b3ddf0&scoped=true&ts=true"
import script from "./ItemFile.vue?vue&type=script&lang=ts"
export * from "./ItemFile.vue?vue&type=script&lang=ts"

import "./ItemFile.vue?vue&type=style&index=0&id=78b3ddf0&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78b3ddf0"]])

export default __exports__